import { Rect } from '../../../platform/geom/Rect';
import { Jukebox } from './Jukebox';

export const JukeboxLayout = (jukebox: Jukebox) => {
    const { width, height } = jukebox;

    const base = new Rect(0, 0, width, height);
    const screen = new Rect(15, 15, 190, 100);

    const shuffle = new Rect(15, screen.bottom + 16, 18, 18);
    const prev = new Rect(shuffle.right + 19, screen.bottom + 12, 26, 26);
    const playPause = prev.set({
        left: prev.right + 19,
    });
    const next = playPause.set({
        left: playPause.right + 19,
    });
    const loop = shuffle.set({
        left: next.right + 19
    });

    return { base, screen, playPause, next, prev, shuffle, loop };
};

export type JukeboxLayout = ReturnType<typeof JukeboxLayout>;
